import axios from 'axios';

export const fipeClient = axios.create({
  baseURL: 'https://veiculos.fipe.org.br/api/veiculos',
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
    Referer: 'https://veiculos.fipe.org.br/',
  },
});

export const parallelumClient = axios.create({
  baseURL: 'https://fipe.parallelum.com.br/api/v2',
  timeout: 10000,
});

export function getParallelumVehicleTypePath(type) {
  const map = { 1: 'cars', 2: 'motorcycles', 3: 'trucks' };
  return map[Number(type)] || 'cars';
}

// Maps internal vehicle types (1=car, 7=moto) to FIPE official API types (1=car, 2=moto, 3=truck)
export function toFipeVehicleType(internalType) {
  const map = { 1: 1, 7: 2 };
  return map[Number(internalType)] ?? Number(internalType);
}
